export default "//yastatic.net/s3/distribution/pythia/frontend/_/7882feaf3a9570af61dbbfb930330956.jpeg";